import { render, staticRenderFns } from "./Imprint.vue?vue&type=template&id=7f8e8b92&scoped=true"
import script from "./Imprint.vue?vue&type=script&lang=js"
export * from "./Imprint.vue?vue&type=script&lang=js"
import style0 from "./Imprint.vue?vue&type=style&index=0&id=7f8e8b92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8e8b92",
  null
  
)

export default component.exports